import React from 'react';
import { Element, PackageAttributes, PriceContainer, TravelTypeBadge } from './PackageSummary.styles';
import { Text, Title } from '@/components/typography';
import Badge from '@/components/badge/Badge';
import { useCruiseItineraryContext } from '@/features/cruise/itinerary/ItineraryDetail/context';
import CruiseDetailList from '@/features/cruise/components/CruiseDetailList/CruiseDetailList';
import TagsBadgeList from '@/features/cruise/components/TagsBadgeList/TagsBadgeList';
import AnchorIcon from '@/components/icons/AnchorIcon/AnchorIcon';

const PackageSummary = () => {
  const { data } = useCruiseItineraryContext();
  const { page } = data;

  return (
    <Element>
      <Title as="h3" size="lg" color="neutral_500" align="center" weight="light">
        Resumo do Cruzeiro
      </Title>
      <PriceContainer>
        {(page.travel_amount && (
          <Text as="span" weight="bold">
            Preço a partir de
          </Text>
        )) ||
          null}

        <Text as="span" size="xl" weight="bold">
          {(!page.travel_amount && (
            <Text as="small" size="md">
              <a href="https://cruzeiros.kangaroo.com.br" target="_blank">
                Mais sugestões aqui
              </a>
            </Text>
          )) || (
            <>
              <Text as="small" size="md">
                {page.travel_currency}
              </Text>{' '}
              {page.travel_amount}
              {(page.travel_currency !== 'BRL' && <sup>*</sup>) || null}
            </>
          )}
        </Text>
        {(page.travel_amount && (
          <Text size="xs" as="small" textCase="uppercase">
            {page.travel_amount_info}
          </Text>
        )) ||
          null}
      </PriceContainer>
      <TravelTypeBadge>
        <Badge size="sm" color="primary_500">
          <AnchorIcon width={16} color="white" />
          Cruzeiros
        </Badge>
      </TravelTypeBadge>
      <TagsBadgeList tags={page.tags} />
      <PackageAttributes>
        <CruiseDetailList {...page} />
      </PackageAttributes>
      <div>
        <Text weight="light" size="xs" color="neutral_600">
          * Valor indicado em moeda estrangeira, convertido em reais de acordo com a cotação do dia do pagamento.
        </Text>
      </div>
    </Element>
  );
};

export default PackageSummary;
